"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountIsland = void 0;
var react_1 = __importDefault(require("react"));
var ThemeProvider_1 = __importDefault(require("@mui/material/styles/ThemeProvider"));
var MsiaTheme_1 = __importDefault(require("./MsiaTheme"));
var IslandErrorBoundary_1 = require("./IslandErrorBoundary");
var renderRoot_1 = require("./renderRoot");
/**
 * Mount a React island into the given DOM element and wrap its content with the
 * shared MSIA MUI ThemeProvider. Use this for every standard island root unless
 * the rendered tree manages its own ThemeProvider — currently only the three
 * "Wrapped*" delegating sidebars (Livestream/Seminar-Leader/Initiate) and
 * Donations/Donate.tsx fall into that category.
 *
 * Internally delegates to {@link renderInto} so the same per-element React-root
 * caching applies; calling `mountIsland` repeatedly on the same DOM node is
 * safe and re-renders rather than re-mounts.
 *
 * Everything mounted this way is wrapped in an error boundary, so a render throw shows a message
 * in place of that island rather than unmounting the tree and leaving a blank page. The three
 * trees that call {@link renderInto} directly manage their own ThemeProvider and are deliberately
 * outside this.
 */
function mountIsland(el, children) {
    (0, renderRoot_1.renderInto)(el, (react_1.default.createElement(ThemeProvider_1.default, { theme: MsiaTheme_1.default },
        react_1.default.createElement(IslandErrorBoundary_1.IslandErrorBoundary, null, children))));
}
exports.mountIsland = mountIsland;
